// extracted by mini-css-extract-plugin
export default {"container":"sortable-item_container__pBrSI","border":"sortable-item_border__Q9gPr","dragHandler":"sortable-item_dragHandler__ALtVv"};